import axios from 'axios'; // 🔧 AXIOS PURO, SIN INTERCEPTOR PROBLEMÁTICO

const apiProductos = process.env.REACT_APP_API_PRODUCTOS;

export const getProductosPorBusquedaService = async (searchInput, limit, offset = 0) => {
    try {
        const response = await axios.get(`${apiProductos}/info`, {
            params: {
                nombre: searchInput,
                limit,
                offset
            }
        });
        return response.data.articulos;
    } catch (error) {
        console.error('Error fetching products:', error);
        throw error;
    }
};

export const getCategoriasService = async () => {
    try {
        const response = await axios.get(`${apiProductos}/categorias`);
        return response.data;
    } catch (err) {
        console.error('Error al obtener los datos:', err);
        throw err;
    }
};

export const getProductosPorSKUService = async (sku) => {
    try {
        const response = await axios.get(`${apiProductos}/busqueda`, {
            params: { sku }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching SKU data:', error);
        throw error;
    }
};

export const getProductosPorSearchInputService = async (busqueda) => {
    try {
        console.log('🔧 SERVICE - Iniciando getProductosPorSearchInputService:', {
            busqueda,
            apiProductos,
            url: `${apiProductos}/busqueda_new`
        });
        
        // 🔧 OBTENER TOKEN DIRECTAMENTE DE LOCALSTORAGE Y PARSEAR JSON
        const tokenRaw = localStorage.getItem('token');
        let token = null;

        try {
            token = tokenRaw ? JSON.parse(tokenRaw) : null;
        } catch (error) {
            // Si no es JSON válido, usar como string limpio
            token = tokenRaw ? tokenRaw.replace(/"/g, '') : null;
        }

        console.log('🔧 SERVICE - Token status:', {
            found: !!token,
            token_raw: tokenRaw ? `${tokenRaw.substring(0, 20)}...` : 'NO TOKEN RAW',
            token_final: token ? `${token.substring(0, 20)}...` : 'NO TOKEN FINAL'
        });
        
        // 🔧 CREAR HEADERS MANUALMENTE
        const headers = {
            'Content-Type': 'application/json'
        };
        
        if (token) {
            headers.Authorization = `Bearer ${token}`;
            console.log('✅ SERVICE - Authorization header agregado');
        } else {
            console.log('❌ SERVICE - NO HAY TOKEN - busqueda sin precios');
        }
        
        console.log('🔧 SERVICE - Headers que se enviarán:', Object.keys(headers));
        
        // 🔧 HACER REQUEST CON AXIOS PURO
        console.log('🔧 SERVICE - PETICIÓN FINAL:', {
            url: `${apiProductos}/busqueda_new?busqueda=${busqueda}`,
            headers: headers,
            token_header: headers.Authorization
        });

        const response = await axios.get(`${apiProductos}/busqueda_new`, {
            params: { busqueda },
            headers,
            timeout: 15000
        });
        
        console.log('🔧 SERVICE - Respuesta completa:', {
            status: response.status,
            response_data: response.data,
            debug_info: {
                debug_clientId: response.data.debug_clientId,
                debug_authenticated: response.data.debug_authenticated
            }
        });
        
        return response.data;
        
    } catch (error) {
        console.error('❌ SERVICE - Error en getProductosPorSearchInputService:', {
            error: error.message,
            status: error.response?.status,
            data: error.response?.data,
            config_url: error.config?.url,
            config_headers: error.config?.headers
        });
        
        throw error;
    }
};